import { Popup } from "semantic-ui-react";

// the call screen is z-index 99999, so its tooltips have to sit above it
function CallPopup(props) {
  return <Popup style={{ zIndex: 999999 }} position="top center" {...props} />;
}

export default CallPopup;
